import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import DerivedQueryForm from './DerivedQueryForm';
import ListDerivedQuery from './ListDerivedQuery';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import ParentCard from '../../../common/ParentCard';

export default class CustomFilterBuilder extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    filters: PropTypes.array,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  showPublishedMessage = () => {
    const { updatedCollections, collection } = this.props;
    const { uuid } = collection;
    if (updatedCollections && updatedCollections.includes(uuid)) {
      return <span className="fw-lighter unpublished-tag text-warning">(Not Published)</span>;
    }
    return '';
  };

  render() {
    const {
      actions,
      commonActions,
      collection,
      projectId,
      filters,
      collections,
      version,
      showQueryCreateLoader,
      flag,
      rls,
    } = this.props;
    const showFilterDeleteLoader = collections.deleteCollectionQueryPending;
    return (
      <div className="row mx-auto">
        <ParentCard
          icon="form"
          header={
            rls ? (
              <>
                Add Row Level Security Filter{' '}
                {typeof collection !== 'undefined' &&
                  collection &&
                  `To ${collection.collectionTitle}`}
                {this.showPublishedMessage()}
              </>
            ) : (
              <>
                Add Filter{' '}
                {typeof collection !== 'undefined' &&
                  collection &&
                  `To ${collection.collectionTitle}`}
                {this.showPublishedMessage()}
              </>
            )
          }
          subtitle={
            rls ? (
              <p className="mx-4 px-5">
                Create customized row level security filters in a collection to filter data entries.
              </p>
            ) : (
              <p className="mx-4 px-5">
                Create customized filters in a collection to filter data entries.
              </p>
            )
          }
        >
          <DerivedQueryForm
            actions={actions}
            commonActions={commonActions}
            collection={collection}
            projectId={projectId}
            version={version}
            collections={collections}
            showQueryCreateLoader={showQueryCreateLoader}
            rls={rls}
          />
        </ParentCard>
        <ParentCard icon="list" header={rls ? 'Row Level Security Filters' : 'Filters'}>
          <ListDerivedQuery
            filters={filters}
            actions={actions}
            commonActions={commonActions}
            version={version}
            projectId={projectId}
            collection={collection}
            showFilterDeleteLoader={showFilterDeleteLoader}
            collections={collections}
            flag={flag}
            rls={rls}
          />
        </ParentCard>
      </div>
    );
  }
}
